export default {
  ar() {
    return {
      item: 'سلعة',
      order_details: 'تفاصيل الطلب',
      phone_number: 'رقم الهاتف:',
      quantity: 'الكمية:',
      total: 'المجموع'
    }
  },

  de() {
    return {
      item: 'Artikel',
      order_details: 'Bestelldaten',
      phone_number: 'TELEFONNUMMER:',
      quantity: 'Quantity:',
      total: 'Gesamtbetrag'
    }
  },

  en() {
    return {
      item: 'Item:',
      order_details: 'Order Details',
      phone_number: 'Phone Number:',
      quantity: 'Quantity:',
      total: 'Total:'
    }
  },

  enGB() {
    return {
      item: 'Item:',
      order_details: 'Order Details',
      phone_number: 'Phone Number:',
      quantity: 'Quantity:',
      total: 'Total:'
    }
  },

  esMX() {
    return {
      item: 'Artículo',
      order_details: 'Detalles de la Orden',
      phone_number: 'NÚMERO DE TELÉFONO:',
      quantity: 'Cantidad:',
      total: 'Total:'
    }
  },

  fr() {
    return {
      item: 'Item:',
      order_details: 'Détails de la commande',
      phone_number: 'NUMÉRO DE TÉLÉPHONE :',
      quantity: 'Qantité:',
      total: 'Total:'
    }
  },

  it() {
    return {
      item: 'Articolo',
      order_details: 'Dettagli dell\'ordine',
      phone_number: 'NUMERO DI TELEFONO:',
      quantity: 'Quantità:',
      total: 'Totale'
    }
  },

  ja() {
    return {
      item: '項目',
      order_details: 'ご注文詳細',
      phone_number: '電話番号:',
      quantity: '数量:',
      total: 'ご請求額'
    }
  },

  pl() {
    return {
      item: 'artykuł',
      order_details: 'szczegóły zamówienia',
      phone_number: 'NUMER TELEFONU:',
      quantity: 'ilość:',
      total: 'ogółem'
    }
  },

  zhCN() {
    return {
      item: '一项',
      phone_number: '电话号码:',
      quantity: '数量:',
      total: '总计'
    }
  }
}
